/* !
 * jQuery news v1.0.0
 * Copyright 2021, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	// ＜ニュースTOP＞ニュース最新年にリダイレクト
	const redirectNewsTop = () => {
		if (FUNCTIONS.va.pathname === '/corporate/news/' || FUNCTIONS.va.pathname === '/corporate/news/index.html' ||
			FUNCTIONS.va.pathname === `/global/${FUNCTIONS.va.region}/news/` || FUNCTIONS.va.pathname === `/global/${FUNCTIONS.va.region}/news/index.html`) {
			let redirectPath = FUNCTIONS.va.pathname;
			redirectPath = redirectPath.replace(/index\.html$/g, ''); // 末尾の index.html を削除
			let pathArr = redirectPath.split('/');
			if (pathArr[pathArr.length - 2] === 'news' && pathArr.length <= 5) {
				location.href = redirectPath + $('.rt_latest_year').text() + '/';
			}
		}
	};

	// ニュース年プルダウン
	const infoYearGenerator = () => {
		const slideSpeed = '400';
		const $latestY = $('.rt_latest_year');
		let $body = $('.mod-news-selectYear-body');

		if ($body.length > 0 && $latestY.length > 0) {
			const startY = 2004;
			const latestY = Number($latestY.text());
			let html = '';

			for (let i = latestY; i >= startY; i--) {
				if (FUNCTIONS.va.isGlobal === -1) {
					html += `<li><a href="/corporate/news/${i}/">${i}年</a></li>`;
				} else {
					html += `<li><a href="/global/${FUNCTIONS.va.region}/news/${i}/">${i}</a></li>`;
				}
			}
			$body.append(html);

			if(FUNCTIONS.va.isGlobal === -1) {
				if (FUNCTIONS.va.pathname.split('/')[3] !== '' && FUNCTIONS.va.pathname.split('/')[3] !== 'index.html') {
					$('.mod-news-selectYear-head span').text(`${FUNCTIONS.va.pathname.split('/')[3]}年`);
				}
			} else {
				if (FUNCTIONS.va.pathname.split('/')[4] !== '' && FUNCTIONS.va.pathname.split('/')[4] !== 'index.html') {
					$('.mod-news-selectYear-head span').text(FUNCTIONS.va.pathname.split('/')[4]);
				}
			}
		}

		if (!FUNCTIONS.va.isMobile) {
			$('.mod-news-selectYear').hover((e) => {
				$(e.currentTarget).addClass(a);
				$(e.currentTarget).find('.mod-news-selectYear-body').stop().slideDown(slideSpeed);
			},
				(e) => {
					$(e.currentTarget).removeClass(a);
					$(e.currentTarget).find('.mod-news-selectYear-body').stop().slideUp(slideSpeed);
				});
		} else {
			$('.mod-news-selectYear-head').on('click', (e) => {
				$(e.currentTarget).parents('.mod-news-selectYear').toggleClass(a);
				$(e.currentTarget).next('.mod-news-selectYear-body').stop().slideToggle(slideSpeed);
			});
		}
	};

	// ========= ↑↑ FUNCTIONS ↑↑ ========================================================================== //

	redirectNewsTop();
	infoYearGenerator();


})(window.jQuery, window.FUNCTIONS);
